import { Component, Inject } from "@angular/core";
import { SideEffect, TransformContextConfig } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: "side-effect-transform-context",
    templateUrl: "./side-effect-transform-context.component.html",
    standalone: false
})
export class SideEffectTransformContext {
    public _sideEffect: SideEffect;

    get conf(): TransformContextConfig {
        const config = this._sideEffect.configuration as TransformContextConfig;
        return config;
    }

    set sideEffect(value: SideEffect) {
        this._sideEffect = value;

        if (!this.sideEffect.configuration)
            this._sideEffect.configuration = {};

        this._fixConfig(this._sideEffect.configuration);
    }

    get sideEffect(): SideEffect {
        return this._sideEffect;
    }

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.sideEffect = data.sideEffect;
    }

    public _fixConfig(seconf: any): void {
        if (!seconf.transforms)
            seconf.transforms = [];
    }

    addRule(): void {
        this.conf.transforms.push({
            contextTarget: "",
            ruleId: "",
            name: "",
            expression: "",
            condition:"true"
        });
    }

    removeRule(index: number): void {
        this.conf.transforms.splice(index, 1);
    }

    swapRules(i: number, j: number) {
        var left = this.conf.transforms[i];
        var right = this.conf.transforms[j];
        this.conf.transforms[i] = right;
        this.conf.transforms[j] = left;
    }
}

